import styled from 'styled-components';

import { ActionButton } from 'components/action-button';

export const Button = styled(ActionButton)`
  width: 48px;
  height: 48px;
  padding: 8px;

  path:not([fill='rgb(255,255,255)']) {
    fill: ${Styles.color.primary};
  }

  &:active path {
    fill: ${Styles.color.white};
  }

  &.loading {
    padding: 0;
  }
`;
